import { render, staticRenderFns } from "./absence.vue?vue&type=template&id=a6870330&scoped=true&"
import script from "./absence.vue?vue&type=script&lang=ts&"
export * from "./absence.vue?vue&type=script&lang=ts&"
import style0 from "./absence.vue?vue&type=style&index=0&id=a6870330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6870330",
  null
  
)

export default component.exports